// Application Configuration and Constants

export const APP_CONFIG = {
    name: 'Only In America',
    shortName: 'TheAmerica.App',
    version: '0.1.2',
    lastUpdated: 'August 27, 2025',
    author: {
        name: 'Joshua Walderbach',
        github: '@8bits1beard',
        handle: '@8bits1beard-io'
    },
    repository: 'https://github.com/8bits1beard-io/project-theamerica',
    description: 'Your Tax Dollars at Work - All Public Data in One Place'
};

export const DATA_SOURCES = {
    census: {
        name: 'US Census Bureau',
        status: 'connected',
        lastUpdate: '2021 ACS 5-year'
    },
    bls: {
        name: 'Bureau of Labor Statistics',
        status: 'connected',
        lastUpdate: '2024'
    },
    cdc: {
        name: 'CDC',
        status: 'connected',
        lastUpdate: '2020'
    },
    nces: {
        name: 'National Center for Education Statistics',
        status: 'connected',
        lastUpdate: '2022-2023'
    }
};

export const METRIC_STATS = {
    totalMetrics: 28,
    dataPoints: 1400,
    completeness: 100.0,
    statesWithData: 50
};

export const THEME = {
    colors: {
        // Patriotic color scheme - Red, White, Blue
        primary: '#002868',     // Old Glory Blue (US Flag Blue)
        secondary: '#BF0A30',   // Old Glory Red (US Flag Red)
        danger: '#BF0A30',      // Old Glory Red
        warning: '#FFD700',     // Gold (for highlights)
        info: '#002868',        // Old Glory Blue
        success: '#00563B',     // Forest Green (complementary)
        dark: '#000033',        // Navy Blue (darker shade)
        light: '#FFFFFF',       // White
        border: '#D0D0D0',      // Light gray for borders
        
        // Additional patriotic colors
        patrioticBlue: '#002868',
        patrioticRed: '#BF0A30',
        patrioticWhite: '#FFFFFF',
        starBlue: '#002868',
        stripeRed: '#BF0A30',
        stripeWhite: '#FFFFFF',
        
        // Background variants
        backgroundLight: '#F8F9FA',
        backgroundPrimary: '#FAFBFC',
        backgroundAccent: '#EBF2FF'
    },
    fonts: {
        primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    transitions: {
        fast: '0.2s ease',
        normal: '0.3s ease',
        slow: '0.5s ease'
    }
};

export const PARTY_COLORS = {
    D: '#1E90FF',
    R: '#DC143C',
    I: '#FFD700',
    default: '#666'
};

export const PARTY_LABELS = {
    D: 'Democrat',
    R: 'Republican',
    I: 'Independent'
};